<template>
  <!-- Loading animation -->
  <div v-show="status == 'loading'">
    <div class="fit row wrap justify-center items-center content-center text-center">
      <div class="col-12">
        <!-- <q-spinner-cube size="6em" color="primary" /> -->
        <div class="cc-loader-center">
          <div class="cc-loader" />
          <div class="cc-loader-bottom" />
          <div class="cc-loader-dot" />
        </div>
      </div>
      <div class="q-mt-xl">
        <p class="text-h5">
          {{ i18n.form_submit_status_loading }}
        </p>
        <span class="text-body2">{{ i18n.form_submit_status_wait }}</span>
      </div>
    </div>
  </div>

  <!-- Workspace Created -->
  <div v-show="status == 'created'">
    <div class="fit row wrap justify-center items-center content-center text-center">
      <div class="col-12">
        <q-icon
          name="las la-check-circle"
          color="positive"
          size="8em"
        />
      </div>
      <div class="q-mt-xl">
        <p class="text-h5">
          {{ i18n.form_submit_status_created }}
        </p>
        <span class="text-body2">{{ i18n.form_submit_status_created_redirect }}</span>
      </div>
    </div>
  </div>

  <!-- Workspace Creation Error -->
  <div v-show="status == 'error'">
    <div class="fit row wrap justify-center items-center content-center text-center">
      <div class="col-12">
        <q-icon
          name="las la-exclamation-circle"
          color="negative"
          size="8em"
        />
      </div>
      <div class="q-mt-xl">
        <p class="text-h5">
          {{ i18n.form_submit_status_error }}
        </p>
        <span class="text-body2 text-negative">{{ error }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  props: {
    i18n: {
      type: Object,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      required: true,
    },
  },
}
</script>
